import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { AlmanacFile, CompletedDesignActions } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { DesignChannel } from 'components/NewFileModal/Types'

interface Props {
  workspaceId: number
}

export interface Data {
  almanac_file: AlmanacFile
}

export interface Variables {
  almanac_file: Pick<AlmanacFile, 'title' | 'parent_id' | 'header_emoji'>
  width: number
  height: number
  channel: DesignChannel
  brand_visual_kit_id?: number
  source_visual_element_id?: number
  apply_brand?: boolean
  completed_actions?: CompletedDesignActions
  template_binder_id?: number
  content?: any
  caption?: string
  selected_caption_id?: number
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const createDesign = async ({
  workspaceId,
  almanac_file,
  width,
  height,
  channel,
  brand_visual_kit_id,
  source_visual_element_id,
  apply_brand,
  completed_actions,
  template_binder_id,
  content,
  caption,
  selected_caption_id,
}: Variables & Props) => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/designs`, {
    method: 'POST',
    body: {
      title: almanac_file.title,
      parent_id: almanac_file.parent_id,
      emoji: almanac_file.header_emoji,
      width,
      height,
      channel,
      brand_visual_kit_id,
      source_visual_element_id,
      template_binder_id,
      completed_actions,
      content,
      selected_caption_id,
      captions: [caption],
      seed: {
        apply_brand,
      },
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useCreateDesign = ({ workspaceId }: Props, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    'createDesign',
    async (variables) => {
      return createDesign({ workspaceId, ...variables })
    },
    {
      ...options,
    },
  )
}
